import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DiaryNoteCard } from '@/components/DiaryNotes/DiaryNoteCard';
import { DiaryNoteModal } from '@/components/DiaryNotes/DiaryNoteModal';
import type { DiaryBehaviourEntry } from '@/types/diary';

interface Props {
  entry: DiaryBehaviourEntry;
}

export const JournalNoteCard: React.FC<Props> = ({ entry }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const item = { ...entry, title: t('diary.notes.behaviourEntry') };

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="group w-full cursor-pointer"
      >
        <DiaryNoteCard hasDate item={item} />
      </button>

      {isOpen && (
        <DiaryNoteModal item={item} onClose={() => setIsOpen(false)} />
      )}
    </>
  );
};
